import DynamicBannerTemplate2 from "./DynamicBannerTemplate2";

export { DynamicBannerTemplate2 as DynamicBannerTemplate2 };

export default DynamicBannerTemplate2;
